
import { Component,Prop, BaseMixins } from '@/lib';
@Component({name:"hi-button"})
export default class HiButton extends BaseMixins{
    @Prop({type:String}) labelKey:string;
    @Prop({type:String}) type:string;
    @Prop({type:String}) icon:string;
    @Prop({type:String}) permission:string;
}
